export enum ETypVH {
    XMET = 'XMET',
    GMET = 'GMET',
    MIXD = 'MIXD',
    SPCL = 'SPCL',
    BMET = 'BMET',
    CMET = 'CMET'
}
